export default __webpack_public_path__ + "static/media/slide16.8c83b0f4.jpg";